// extracted by mini-css-extract-plugin
export default {"title":"styles_title__8XpTQ","name":"styles_name__8pXpi"};